// extracted by mini-css-extract-plugin
module.exports = {"root":"Security_root__1rDo4","main":"Security_main__73Y-A","rowWithButton":"Security_rowWithButton__3iXvI"};